 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		96: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~pages-admin-teams~pages-class-details-logged-in~pages-class-details-logged-out~pages-class-d~056cf466","1":"vendors~pages-adminMarketingBanner~pages-class-details-logged-in~pages-class-details-logged-out~page~19f89f02","2":"vendors~pages-adminMarketingBanner~pages-class-details-logged-in~pages-class-details-logged-out~page~e68b6694","3":"dllVendors","4":"vendors~pages-adminMarketingBanner~pages-classes~pages-classes-class-collections~pages-home~pages-si~675aa492","5":"tinymce","6":"vendors~pages-adminMarketingBanner~pages-class-details-logged-out~pages-classes-class-collections~pa~46bad615","7":"d3","8":"pages-embed-video~pages-site-join","9":"pages-site-settings-payment~pages-teams-checkout","10":"vendors~pages-site-gallery~pages-workshops-show","11":"pages-adminMarketingBanner","12":"pages-amas","13":"pages-class-details-logged-in","14":"pages-class-details-logged-out","15":"pages-class-details-reviews","16":"pages-classes","17":"pages-customLists","18":"pages-error","19":"pages-home","20":"pages-marketingPages","21":"pages-notifications","22":"pages-projects","23":"pages-redeem","24":"pages-search","25":"pages-site","26":"pages-teach","27":"pages-teacherStats","28":"pages-teaching","29":"pages-teams","30":"pages-userProfile","31":"pages-visa","32":"pages-yourClasses","33":"vendors~pages-search","34":"vendors~pages-visa","35":"pages-admin-adjust-team-seats","36":"pages-admin-batch-delete-users","37":"pages-admin-coupons","38":"pages-admin-monthly-revenue","39":"pages-admin-teacher-payout","40":"pages-admin-teams","41":"pages-admin-trust-and-safety","42":"pages-admin-users-show","43":"pages-adminMarketingBanner-edit","44":"pages-amas-form","45":"pages-checkout-item","46":"pages-class-details-logged-in-class-admin","47":"pages-classes-class-collections","48":"pages-classes-create","49":"pages-classes-video-lessons-table","50":"pages-customLists-form","51":"pages-customLists-lists","52":"pages-customLists-show","53":"pages-embed-project","54":"pages-embed-video","55":"pages-giftCards-form","56":"pages-membership-cancel","57":"pages-membership-cancel-step-two","58":"pages-membership-paypal-cancel","59":"pages-membership-paypal-success","60":"pages-membership-perks","61":"pages-membership-react-checkout","62":"pages-membership-rejoin","63":"pages-membership-welcome","64":"pages-projects-edit","65":"pages-reviews-create","66":"pages-site-gallery","67":"pages-site-join","68":"pages-site-login","69":"pages-site-premium-landing","70":"pages-site-scholarships","71":"pages-site-settings-account","72":"pages-site-settings-notifications","73":"pages-site-settings-payment","74":"pages-site-settings-react-account","75":"pages-site-settings-referrals","76":"pages-site-settings-teacher-referrals","77":"pages-site-settings-team-administration","78":"pages-teach-form","79":"pages-teach-handbook","80":"pages-teams-activate","81":"pages-teams-checkout","82":"pages-teams-contact","83":"pages-teams-new","84":"pages-teams-signup","85":"pages-userProfile-discussionShow","86":"pages-userProfile-discussions","87":"pages-visa-check","88":"pages-visa-footer","89":"pages-visa-header","90":"pages-workshops-form","91":"pages-workshops-show","92":"pages-workshops-test-index","93":"vendors~pages-membership-react-checkout","94":"vendors~pages-projects-edit","95":"vendors~pages-visa-header"}[chunkId]||chunkId) + ".build." + {"0":"d8ff1f5645badc3c95f8","1":"db7fedf52727ce18b700","2":"87252d93e763258e61a9","3":"0291089829f3e3cdafaf","4":"c21c720b89c5d8880aaa","5":"01bc7e3a369a48c3faf9","6":"02316c5b6cd572f6bbd4","7":"dcef8f19f1fd897c67be","8":"8d74dae85ee7032f4bda","9":"7747de00072b0effa0a5","10":"be30dffaec900e531815","11":"4aaea9f60a596bce855d","12":"637b4cfc8f82b556ff85","13":"a490ad77b73c98f0d9af","14":"368f560a086a2003522b","15":"284fa086720183ae43f4","16":"cb1aa42265b2adf1bdcc","17":"d064f343e627d550d9aa","18":"5986723557e52966495e","19":"014cce47b8bdfd121a6d","20":"bbb70ee2281f91c3d7fd","21":"58e14b1c5667b3470650","22":"517c6f50530f717057f9","23":"234d4e682dbc8a40fa6c","24":"9d1b52c4fdf28355622d","25":"a424d05a51f4eb3e761e","26":"f03bcde27bce39937ac2","27":"2e5226255e22ee7530a2","28":"08d3f70b32c29831fa19","29":"0c6d323666716c87de4f","30":"0a6678f25e6e46dfbdca","31":"559caadeb1e3e18ccdda","32":"220f1d0a8cabc5b0d33e","33":"92d2ba52d7f0ce3d8a6a","34":"88740f5afe8d32890a16","35":"b7cd51702b26cd947710","36":"50055b91c89d93aa50ba","37":"9d0e351458bcc33908b0","38":"ff77094af07ea418c353","39":"6904b0b669c2130c4ea5","40":"59be5f1891d01325fd9e","41":"de36fae6037322f02b14","42":"8e13c3d43a171dc7b2fb","43":"63aa380691d580a623e8","44":"b1d6735ba07200bf7769","45":"83519f2000c5b83a4eda","46":"8480af64d8e059ee1f59","47":"3e367c4330a0dcecdf1d","48":"d61fadcaba05bd5e9162","49":"c97619a52b283aae10eb","50":"5cdb5d4c71370596a89c","51":"8fd51dc1f9b46e77f990","52":"f11b1e93136aa70df92d","53":"06cb26c7a02ee5ed6e62","54":"97e4468fa03eac8b5101","55":"4019e510c818f8909b35","56":"2cb41e68fab175c71ded","57":"4237b13bb4bbe28c7e3f","58":"82881f7cb92aef5994a1","59":"bbb98d369dbeb218dbed","60":"5f1e2522f6fd9540dab6","61":"868363ec8a2dada4840a","62":"1d49451c709a40577f8a","63":"0f168ccd22457f6078fc","64":"245aadf1d818890fa849","65":"ee512e8ce0a55fcfb359","66":"c75561e113b4a5447e27","67":"f5a25111e87c447bb73f","68":"5884c63dfc39b32b3b2e","69":"873c6f0d1b543cf2bb9e","70":"c10cf781704a2c7528be","71":"6771c4de8a4c6fc9606c","72":"62fca5ad12b03b3b176d","73":"90f03d97b700d37b57ac","74":"08afa9929f5034963bd4","75":"d57ca15de3a3fa46b4bd","76":"086907da9847bb56a18c","77":"9a4261a3be36e3cd3ef3","78":"399117848e78fef3d581","79":"de234d98d9ae6c98a59b","80":"2ae19d454fbfa584410c","81":"5ff4ab2218a278d423b9","82":"9ec54f6e9ee71ce7615e","83":"e43b41c4c4c0b53d3616","84":"7fee0ea59ce8e913096b","85":"e59fc69b7365f2cb75bc","86":"13a1c035e4bb0737acc2","87":"0ac6fc6601200191a469","88":"248822814f55d1c6174c","89":"7634375ceab05503f2b6","90":"7104e6315317279f8f4d","91":"25c99851962999c698e0","92":"405faf9428201e350fe6","93":"a9474465743ec87e350e","94":"52a0c09870b86bab1117","95":"3b32adb32e295ea1cdb6","97":"e5f271aac1cd84750420","98":"35323f3bda6271a65a73"}[chunkId] + ".min.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.skillshare.com/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 723);
